<template>
  <div id="app">
    <div class="xs_page_wrapper">
      <Header />
        <router-view/>
      <Footer />
     <ZoomBar />
    </div>
  </div>
</template>

<script>
import Footer from './components/Footer'
import Header from './components/Header'
import ZoomBar from './components/ZoomBar'
export default {
  components: {ZoomBar, Footer, Header},
  data () {
    return {
      test: true
    }
  },
  mounted () {
    // let a = document.createElement('script')
    // a.setAttribute('src', '../static/dist/js/jquery/jquery.min.js')
    // document.head.appendChild(a)
  }
}
</script>
<style>
  @import '../static/dist/css/dist/block-library/style.min.css';
  @import '../static/dist/css/dist/block-library/style.min.css';
  @import '../static/dist/plugins/contact-form-7/includes/css/styles.css';
  @import '../static/dist/plugins/revslider/public/assets/css/rs6.css';
  @import '../static/dist/customs/kits/modules/elementskit-icon-pack/assets/css/ekiticons.css';
  @import '../static/dist/uploads/titan-framework-wdc-options-css.css';
  @import '../static/dist/customs/plugins/assets/lib/eicons/css/elementor-icons.min.css';
  @import '../static/dist/customs/plugins/assets/css/frontend-legacy.min.css';
  @import '../static/dist/customs/plugins/assets/css/frontend.min.css';
  @import '../static/dist/uploads/elementor/css/post-1589.css';
  @import '../static/dist/customs/plugins/assets/lib/font-awesome/css/font-awesome.min.css';
  @import '../static/dist/uploads/elementor/css/global.css';
  @import '../static/dist/uploads/elementor/css/post-6.css';
  @import '../static/dist/customs/themes/assets/css/bootstrap.min.css';
  @import '../static/dist/customs/themes/assets/css/magnific-popup.css';
  @import '../static/dist/customs/themes/assets/css/xs_main.css';
  @import '../static/dist/customs/themes/assets/css/blog-style.css';
  @import '../static/dist/customs/themes/assets/css/animate.css';
  @import '../static/dist/customs/themes/assets/css/owl.carousel.min.css';
  @import '../static/dist/customs/themes/assets/css/owl.theme.default.min.css';
  @import '../static/dist/customs/themes/assets/css/jquery-ui.structure.min.css';
  @import '../static/dist/customs/themes/assets/css/jquery-ui.theme.min.css';
  @import '../static/dist/customs/themes/assets/css/domain-checker/style.css';
  @import '../static/dist/customs/themes/assets/css/iconfont.css';
  @import '../static/dist/customs/themes/assets/css/navigation.min.css';
  @import '../static/dist/customs/themes/assets/css/style.css';
  @import '../static/dist/customs/themes/assets/css/gutenberg-custom.css';
  @import '../static/dist/customs/themes/assets/css/responsive.css';
  @import '../static/dist/customs/kits/widgets/init/assets/css/widget-styles.css';
  @import '../static/dist/customs/kits/widgets/init/assets/css/responsive.css';
</style>



// WEBPACK FOOTER //
// src/App.vue